import { render, staticRenderFns } from "./contentful-image.vue?vue&type=template&id=3f1ce1a9&scoped=true&"
import script from "./contentful-image.vue?vue&type=script&lang=ts&"
export * from "./contentful-image.vue?vue&type=script&lang=ts&"
import style0 from "./contentful-image.vue?vue&type=style&index=0&id=3f1ce1a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ce1a9",
  null
  
)

export default component.exports